/** @jsxImportSource @emotion/react */
import React, { FC, memo } from 'react';
import { useTranslation } from 'react-i18next';
import { Divider, Fade, Grid } from '@mui/material';
import { MenuItemResponse, MenuType } from 'api/models';
import ItemGroup from 'components/ItemGroup';
import MenuItemCard from 'pages/Menu/components/MenuItemCard/MenuItemCard';
import { formatDayLabel } from 'utils/formatDayLabel';
import { getMenuTypeText } from 'utils/getMenuTypeText';
import { Props } from './types';

const MenuList: FC<Props> = ({
  items,
  cart,
  onAdd,
  onRemove,
  editable = true,
  menuType,
  dayDate,
}) => {
  const { t } = useTranslation();

  // The next-stack menu is a single menu (one type), so all items form one group.
  const groups: Array<[string, MenuItemResponse[]]> = [[menuType ?? '', items]];

  return (
    <Fade in>
      <Grid container direction="column" spacing={6}>
        {groups.map(([menuType, groupItems], index) => (
          <React.Fragment key={menuType}>
            <ItemGroup
              title={t(getMenuTypeText(menuType as MenuType))}
              caption={dayDate && formatDayLabel(dayDate)}
            >
              {groupItems.map((item) => (
                <Grid item key={item.id}>
                  <MenuItemCard
                    item={item}
                    quantity={cart[item.id!]?.quantity}
                    inCart={!!cart[item.id!]}
                    editable={editable}
                    onAdd={onAdd}
                    onRemove={onRemove}
                  />
                </Grid>
              ))}
            </ItemGroup>

            {index !== groups.length - 1 && (
              <Grid item>
                <Divider />
              </Grid>
            )}
          </React.Fragment>
        ))}
      </Grid>
    </Fade>
  );
};

export default memo(MenuList);
